import React from 'react';
import styled from '@emotion/styled';

import ImageLightbox from '../components/presentational/ImageLightbox';

const ModalWrapper = styled('div')`
  display: flex;
  width: 100%;
  .modal-button {
    align-items: center;
    background: '#ff6600';
  }
`;

const RecordVideoModal = () => (
  <ModalWrapper>
    <ImageLightbox />
  </ModalWrapper>
);

RecordVideoModal.propTypes = {
};

export default RecordVideoModal;
